import { apiClient } from './api'
import type { User, RegisterPayload, LoginPayload, AuthResponse } from '../types'

export async function register(payload: RegisterPayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>('/auth/register', { user: payload })
  return data
}

export async function login(payload: LoginPayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>('/auth/sessions', { user: payload })
  return data
}

export async function logout(): Promise<void> {
  await apiClient.delete('/auth/sessions')
}

export async function getCurrentUser(): Promise<User> {
  const { data } = await apiClient.get<User>('/profile')
  return data
}
